module.exports = __webpack_public_path__ + "static/EngraversMT-4c2cc536eab58f58dc06aa7258b1a33a.svg";